import { render, staticRenderFns } from "./TrendingLosersTickersWidgetWrapper.vue?vue&type=template&id=d9b62070"
import script from "./TrendingLosersTickersWidgetWrapper.vue?vue&type=script&lang=js"
export * from "./TrendingLosersTickersWidgetWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Card: require('/skade-pwa/components/ui/atom/Card.vue').default})
